import { cubicEaseOut } from '@helpers/animate';
import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { h6, paragraphMicro, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.article `
  display: flex;
  background: ${brand.white};
  border-radius: 16px;
  flex-direction: column;
  overflow: hidden;
  text-align: left;
  height: 100%;
`;
const Link = styled.a `
  display: flex;
  flex-direction: column;
  height: 100%;
  color: currentColor;
  text-decoration: none;
`;
const ImageWrapper = styled.div `
  position: relative;
  height: 0;
  overflow: hidden;
  padding-bottom: calc(280 / 480 * 100%);
`;
const Image = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1);
  transition: transform 1s ${cubicEaseOut};
  width: 100%;

  ${Link}:focus &,
  ${Link}:hover & {
    transform: scale(1.2);
  }
`;
const ContentWrapper = styled.div `
  padding: 32px 24px;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;

  ${Container}[data-theme='grey'] & {
    background-color: ${brand.lightGrey};
  }
`;
const Metadata = styled.div `
  ${paragraphMicro}
  margin-bottom: 14px;
`;
const Date = styled.time `
  ${fonts.montserrat.bold}
`;
const Title = styled.h3 `
  ${h6}
  margin-bottom: 24px;
`;
const Content = styled.p `
  ${paragraphSmall}
  margin-bottom: 0;
`;
const CtaWrapper = styled.div `
  margin-top: auto;
  padding-top: 24px;
`;
const ArticleCardStyles = {
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Date,
    Image,
    ImageWrapper,
    Link,
    Metadata,
    Title,
};
export default ArticleCardStyles;
